
import './App.css';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import Triage from './pages/Triage';
import Payment from './pages/Paymet';
import MRIQueue from './pages/MRIQueue';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Dashboard from './pages/Dashboard';
import CustomerService from './pages/CustomerService';

function App() {
  const [cases, setCases] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/cases`).then((res) => {
      setCases(res.data)
    }).catch(err => {
      alert("Error Connecting to database")
    })
  }, [!cases])

  return (
    <div className="App">
      <header>
        <img src='/logo.png' className="logo" alt="logo" />
       
        <nav>          
          <a href="/triage" className='triage-link'>Triage</a>
          <a href="/payment" className='payment-link'>Payment</a>
          <a href="/queue"  className='queue-link'>Queue</a>
          <a href="/dashboard"  className='dashboard-link'>Dashboard</a>
          <a href="/customer-service" className='customer-service-link'>Customer Service</a>
        </nav>
        <div>
          <p>Amanuel</p>
        </div>
      </header>
      <main>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Triage cases={cases} />} />
            <Route path="/triage" element={<Triage cases={cases} />} />
            <Route path="/payment" element={<Payment cases={cases} />} />
            <Route path="/queue" element={<MRIQueue cases={cases} />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/customer-service" element={<CustomerService />} />
          </Routes>
        </BrowserRouter>
      </main>
    </div>
  );
}

export default App;
